/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TFilterPikNewbuildingsModel,
  IFilterPikNewbuildingsRequest,
  IMappers,
  IFilterPikNewbuildingsResponse,
  IFilterPikNewbuildingsResponseError,
  TFilterPikNewbuildingsResponse,
} from './types';

const defaultConfig: TFilterPikNewbuildingsModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/filter-pik-newbuildings/',
  hostType: 'api',
} as TFilterPikNewbuildingsModel;

function createFilterPikNewbuildingsModel(parameters: IFilterPikNewbuildingsRequest): TFilterPikNewbuildingsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IFilterPikNewbuildingsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IFilterPikNewbuildingsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchFilterPikNewbuildings<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IFilterPikNewbuildingsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TFilterPikNewbuildingsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createFilterPikNewbuildingsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IFilterPikNewbuildingsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IFilterPikNewbuildingsResponseError);
    }
  }

  return { response, statusCode } as TFilterPikNewbuildingsResponse;
}

export { defaultConfig, createFilterPikNewbuildingsModel, fetchFilterPikNewbuildings };
